import { isServer } from './ssr';

export function getApolloFetchUrl() {
  if (isServer()) {
    return process.env.GQL_API;
  }
  return `${window.origin}/api/graphql`;
}
